// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2rk3y","selected":"Chip_selected__34_iy"};